// src/components/ShineBorder.jsx
import React from "react";

// Simple className merger (since you don't have "@/lib/utils/cn")
function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * ShineBorder
 *
 * An animated background border effect component.
 * Put this inside a relatively-positioned container that has
 * rounded corners and overflow hidden.
 */
export function ShineBorder({
  borderWidth = 10,
  duration = 14,
  shineColor = "#000000",
  className,
  style,
  ...props
}) {
  const colors = Array.isArray(shineColor) ? shineColor.join(",") : shineColor;

  return (
    <div
      style={{
        "--shine-duration": `${duration}s`,
        "--border-width": `${borderWidth}px`,
        backgroundImage: `linear-gradient(90deg, ${colors}, ${colors})`,
        backgroundSize: "300% 100%",
        mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMask:
          "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMaskComposite: "xor",
        maskComposite: "exclude",
        padding: "var(--border-width)",
        ...style,
      }}
      className={cn("shine-border", className)}
      {...props}
    />
  );
}
